import React from 'react';

interface ConfirmDialogProps {
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  danger?: boolean;
  children?: React.ReactNode;
  onConfirm: () => void;
  onCancel: () => void;
}

export function QuantityField({
  value,
  min = 1,
  max,
  onChange,
  label = 'Anzahl',
}: {
  value: number;
  min?: number;
  max: number;
  onChange: (next: number) => void;
  label?: string;
}) {
  const clamp = (next: number) => Math.min(max, Math.max(min, Number.isFinite(next) ? next : min));
  return (
    <div className="qty-field">
      <label className="qty-field-label" htmlFor="qty-field-input">{label}</label>
      <div className="qty-field-controls">
        <button
          type="button"
          className="vital-edit-btn vital-edit-btn-minus"
          aria-label="Weniger"
          disabled={value <= min}
          onClick={() => onChange(clamp(value - 1))}
        >
          −
        </button>
        <input
          id="qty-field-input"
          className="vital-edit-value-input"
          type="number"
          min={min}
          max={max}
          value={value}
          aria-label={label}
          onChange={(event) => onChange(clamp(parseInt(event.target.value, 10)))}
        />
        <button
          type="button"
          className="vital-edit-btn vital-edit-btn-plus"
          aria-label="Mehr"
          disabled={value >= max}
          onClick={() => onChange(clamp(value + 1))}
        >
          +
        </button>
        <span className="qty-field-max">von {max}</span>
      </div>
    </div>
  );
}

export function ConfirmDialog({
  title,
  message,
  confirmLabel = 'Bestätigen',
  cancelLabel = 'Abbrechen',
  danger = false,
  children,
  onConfirm,
  onCancel,
}: ConfirmDialogProps) {
  return (
    <div className="modal-overlay" data-gamepad-overlay="modal" onClick={onCancel} role="presentation">
      <div
        className="modal-content confirm-dialog"
        onClick={e => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="confirm-dialog-title"
      >
        <div className="modal-header">
          <h2 id="confirm-dialog-title">{title}</h2>
          <button type="button" className="modal-close" data-gamepad-dismiss onClick={onCancel} aria-label="Schließen">✕</button>
        </div>
        <div className="modal-body">
          <p className="confirm-dialog-message">{message}</p>
          {children}
        </div>
        <div className="modal-footer">
          <button type="button" className="medieval-button cancel-btn" onClick={onCancel}>
            {cancelLabel}
          </button>
          <button
            type="button"
            className={`medieval-button create-btn ${danger ? 'danger-btn' : ''}`}
            onClick={onConfirm}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
